import { FC } from 'react'

import { Space, SpaceProps } from '../Space'

export const FieldSpace: FC<SpaceProps> = ({ children, ...spaceProps }) => (
  <Space
    direction="horizontal"
    space={2}
    flexDirection={['row', 'row', null]}
    height="100%"
    alignItems={[null, null, 'center']}
    {...spaceProps}
  >
    {children}
  </Space>
)
